var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[(!_vm.willCreateDoc && (_vm.hasErrors || _vm.hasInfos || _vm.skipRow))?_c('i',{staticClass:"zmdi zmdi-alert-circle-o c-error f-16",class:`tippy-errors-${_vm._uid}`}):_vm._e(),(!_vm.hasErrors && _vm.willCreateDoc)?_c('i',{staticClass:"zmdi zmdi-alert-circle-o f-16",class:`tippy-errors-${_vm._uid}`}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }